import { APP_ROUTE } from '../../constants';

export const navigationKeys = {
  HOME: 'home',
  CONNECTIONS: 'connections',
  ANALYTICS: 'analytics',
  EMBED: 'embed',
  CHARTS: 'charts',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  Bell: 'bell',
};

const disabledNavigationKeys = [navigationKeys.CHARTS];

export const navigationItems = [
  {
    icon: 'home',
    label: 'Home',
    key: navigationKeys.HOME,
    baseRoute: APP_ROUTE.HOME,
  },
  {
    icon: 'datasources',
    label: 'Connections',
    key: navigationKeys.CONNECTIONS,
    baseRoute: APP_ROUTE.CONNECTIONS,
  },
  {
    icon: 'analytics',
    label: 'Analytics',
    key: navigationKeys.ANALYTICS,
    baseRoute: APP_ROUTE.ANALYTICS,
  },
  {
    icon: 'embed',
    label: 'Embed',
    key: navigationKeys.EMBED,
    baseRoute: APP_ROUTE.EMBED,
  },
  {
    icon: 'chart',
    label: 'Charts',
    key: navigationKeys.CHARTS,
    baseRoute: APP_ROUTE.CHARTS,
  },
  {
    icon: 'reports-navigation',
    label: 'Reporting',
    key: navigationKeys.REPORTS,
    baseRoute: APP_ROUTE.REPORTS,
  },
  {
    icon: 'settings',
    label: 'Settings',
    key: navigationKeys.SETTINGS,
    baseRoute: APP_ROUTE.SETTINGS,
  },
  // {
  //   icon: 'notification-bell',
  //   label: `See what's new`,
  //   key: navigationKeys.Bell,
  //   baseRoute: navigationKeys.Bell,
  // },
  // filter temporary disabled nav items
].filter(({ key }) => !disabledNavigationKeys.includes(key));

export const subNavigationKeys = {
  DATASOURCES: 'datasources',
  DESTINATION: 'destinations',
  CUSTOM_METRICS: 'customMetrics',
  CAMPAIGNS: 'campaigns',
};

const disabledSubNavigationKeys = [
  subNavigationKeys.CUSTOM_METRICS,
  subNavigationKeys.CAMPAIGNS,
];

export const subNavigationItems = {
  [navigationKeys.HOME]: [],
  [navigationKeys.CONNECTIONS]: [
    {
      label: 'Data sources',
      to: `/${APP_ROUTE.CONNECTIONS}/${APP_ROUTE.DATA_SOURCES}`,
      key: subNavigationKeys.DATASOURCES,
    },
    {
      label: 'Destinations',
      to: `/${APP_ROUTE.CONNECTIONS}/${APP_ROUTE.DESTINATION}`,
      key: subNavigationKeys.DESTINATION,
    },
    {
      label: 'Custom metrics',
      to: '',
      key: subNavigationKeys.CUSTOM_METRICS,
    },
    {
      label: 'Campaigns',
      to: '',
      key: subNavigationKeys.CAMPAIGNS,
    },
  ].filter(({ key }) => !disabledSubNavigationKeys.includes(key)),
  [navigationKeys.ANALYTICS]: [
    {
      label: 'Overview',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.OVERVIEW}`,
    },
    {
      label: 'Social media',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.DASHBOARD}`,
    },
    {
      label: 'Social posts',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.POSTS}`,
    },
    {
      label: 'Ads',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.ADS}`,
    },
    {
      label: 'Email',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.EMAIL}`,
    },
    {
      label: 'Website',
      to: `/${APP_ROUTE.ANALYTICS}/${APP_ROUTE.WEBSITE}`,
    },
  ],
  [navigationKeys.EMBED]: [
    {
      label: 'Charts',
      to: `/${APP_ROUTE.EMBED}/${APP_ROUTE.CHARTS}`,
    },
  ],
  [navigationKeys.REPORTS]: [
    {
      label: 'Reports',
      to: `/${APP_ROUTE.REPORTS}`,
    },
    {
      label: 'Templates',
      to: `/${APP_ROUTE.REPORTS}/${APP_ROUTE.TEMPLATES}/${APP_ROUTE.LIST}`,
    },
  ],
  [navigationKeys.SETTINGS]: [
    {
      label: 'Profile',
      to: `/${APP_ROUTE.SETTINGS}/${APP_ROUTE.PROFILE}`,
    },
    {
      label: 'Account',
      to: `/${APP_ROUTE.SETTINGS}/${APP_ROUTE.ACCOUNT}`,
    },
    {
      label: 'Workspace',
      to: `/${APP_ROUTE.SETTINGS}/${APP_ROUTE.WORKSPACE}`,
    },
    {
      label: 'Team',
      to: `/${APP_ROUTE.SETTINGS}/${APP_ROUTE.TEAM}`,
      isProtected: true,
      key: 'team',
    },
    {
      label: 'Billing',
      to: `/${APP_ROUTE.SETTINGS}/${APP_ROUTE.BILLING}`,
    },
  ],
};
